import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ManageBidInstructionService } from '../manage-bid-instruction.service';

@Component({
  selector: 'app-bid-instruction-queue',
  templateUrl: './bid-instruction-queue.component.html',
  styleUrls: ['./bid-instruction-queue.component.scss']
})

export class BidInstructionQueueComponent implements OnInit {

  @Output() closeBidQueDialog = new EventEmitter<boolean>();
  @Input() showBidQueDialog: boolean;

  cols: any[];
  data: any[];
  records: number;
  loading: boolean = true;

  constructor(private manageBidInstructionService: ManageBidInstructionService) { }

  ngOnInit() {
    this.cols = [
      { field: 'Loan', header: 'Loan#', showInHeader: true },
      { field: 'TaskName', header: 'Task Name', showInHeader: true },
      { field: 'Status', header: 'Status', showInHeader: true },
      { field: 'PropertyId', header: 'Property ID', showInHeader: false },
      { field: 'propertyUrl', showInHeader: false }
    ]
    this.manageBidInstructionService.getBidInstructionQueueData().subscribe(res => {
      this.data = res;
      this.records = res.length;
      this.loading = false;
    });
  }

  isPaginatorVisible(): boolean {
    return (this.data && this.data.length > 0) ? true : false;
  }
  bidQuedialogHide() {
    this.closeBidQueDialog.emit(true);
  }

}
